import i18n from "../i18n";

const MONTHS: Record<string, string[]> = {
    en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    sk: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    cs: ['Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čvn', 'Čvc', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro'],
    de: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    ro: ['Ian', 'Feb', 'Mar', 'Apr', 'Mai', 'Iun', 'Iul', 'Aug', 'Sep', 'Oct', 'Noi', 'Dec'],
    pl: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    hu: ['Jan', 'Feb', 'Márc', 'Ápr', 'Máj', 'Jún', 'Júl', 'Aug', 'Szept', 'Okt', 'Nov', 'Dec'],
    it: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
};


const getLocalizedMonthFromIso = (iso: string): string => {
    if (!iso) return '';
    const [year, month] = iso.split('-');
    const monthIndex = parseInt(month, 10) - 1;
    const lang = i18n.language || 'en';
    const monthName = MONTHS[lang]?.[monthIndex] ?? month;
    return `${monthName} ${year}`;
};

// Map of field keys to their translation keys
const translationKeys: Record<string, string> = {
    period: "enum.period",
    received_payments: "enum.received_payments",
    new_enrollments: "enum.new_enrollments",
    ended: "enum.ended",
    net_revenue: "enum.net_revenue",
    revenue: "enum.revenue",
    enrollments: "enum.enrollments",
    cancellations: "enum.cancellations",
    royalties: "enum.royalties",
    company_name: "enum.company_name",
    name: "enum.name",
    product_code_id: "enum.product_code_id",
    __unpaid_enrollments__: "enum.unpaid_enrollments",
    unpaid_debt: "enum.unpaid_debt",
    unpaid_enrollments: "enum.unpaid_enrollments",
    instructors: "enum.instructors",
    sessions_with_attendance: "enum.sessions_with_attendance",
    received_payments_total: "enum.received_payments_total",
    new_enrollments_total: "enum.new_enrollments_total",
    ended_total: "enum.ended_total",
    net_revenue_total: "enum.net_revenue_total",
    revenue_total: "enum.revenue_total",
    royalties_total: "enum.royalties_total",
    cancellations_average: "enum.cancellations_average",
    enrollments_average: "enum.enrollments_average",
    __unpaid_enrollments___average: "enum.unpaid_enrollments_average",
    place_name: "enum.place_name"
};

export const enums = (key: string): string => {
    // All enum translation keys for extractor to find
    i18n.t("enum.period");
    i18n.t("enum.received_payments");
    i18n.t("enum.new_enrollments");
    i18n.t("enum.ended");
    i18n.t("enum.net_revenue");
    i18n.t("enum.revenue");
    i18n.t("enum.enrollments");
    i18n.t("enum.cancellations");
    i18n.t("enum.royalties");
    i18n.t("enum.company_name");
    i18n.t("enum.name");
    i18n.t("enum.product_code_id");
    i18n.t("enum.unpaid_enrollments");
    i18n.t("enum.unpaid_debt");
    i18n.t("enum.instructors");
    i18n.t("enum.sessions_with_attendance");
    i18n.t("enum.received_payments_total");
    i18n.t("enum.new_enrollments_total");
    i18n.t("enum.ended_total");
    i18n.t("enum.net_revenue_total");
    i18n.t("enum.revenue_total");
    i18n.t("enum.royalties_total");
    i18n.t("enum.cancellations_average");
    i18n.t("enum.enrollments_average");
    i18n.t("enum.unpaid_enrollments_average");
    i18n.t("enum.paid_enrollments");
    i18n.t("enum.place_name")

    // Direct translation lookup - call i18n.t() at runtime with proper translation keys
    if (translationKeys[key]) {
        return i18n.t(translationKeys[key]);
    }

    if (key && key.endsWith('_total')) {
        const base = key.replace('_total', '');
        const label = translationKeys[base] ? i18n.t(translationKeys[base]) : base;
        return `${label} ${i18n.t("enum.total_suffix")}`;
    }

    if (key && key.endsWith('_average')) {
        const base = key.replace('_average', '');
        const label = translationKeys[base] ? i18n.t(translationKeys[base]) : base;
        return `${label} ${i18n.t("enum.average_suffix")}`;
    }

    // Dynamicky: napr. "received_payments_2025-07"
    const match = key && key.match(/^(.+?)_(\d{4}-\d{2})$/);
    if (match) {
        const metric = match[1];
        const period = match[2];
        const translatedMetric = translationKeys[metric] ? i18n.t(translationKeys[metric]) : metric;
        const localizedMonthYear = getLocalizedMonthFromIso(period);
        return `${translatedMetric} ${localizedMonthYear}`;
    }

    return key || '';
};
